// eslint-disable-next-line @typescript-eslint/typedef, @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export const CONSTANT = {
} as const;

export enum ProductType {
	SEA_FOOD = 'SEA_FOOD',
	MEAT = 'MEAT',
	FRUIT = 'FRUIT',
	VEGETABLES = 'VEGETABLES',
	SPICE = 'SPICE',
	DRY_FOOD = 'DRY_FOOD',
}
